import axios from "axios";
import {
    MessageBox,
    Message
} from "element-ui";
import qs from "qs";
import { cdEncrypt } from "@/utils/cdEncryption";
import serverUrl from "@/config/BaseConfigs";
const service = axios.create({
    baseURL: serverUrl.cdServerUrl,
    timeout: 10000, // request timeout
});
// request interceptor
service.interceptors.request.use(
    (config) => {
        if (config.method === "post") {
            let res = qs.stringify(cdEncrypt(config.data));
            config.data = res;
        }
        return config;
    },
    (error) => {
        console.log(error); // for debug
        return Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    (response) => {
        const res = response.data;
        if (res.success !== 1) {
            Message({
                message: res.message || 'Error'
            })
            if (res.message == "noLoginMessage") {
            }
            return Promise.reject(new Error(res.message || "Error"));
        } else {
            return res;
        }
    },
    (error) => {
        // Message({
        //     message: error.message,
        //     type: 'error',
        //     duration: 5 * 1000
        // })
        return Promise.reject(error);
    }
);

export default service;
